import { NameAndOptions } from "@me8eon/string_utils";


export function aggregateAllQuerys(inputs: NameAndOptions[]): Record<string, any> {
    const results = inputs.map(aggregateQueryGenerator).filter((x): x is [string, any] => x !== null) as [string, any][];
    return Object.fromEntries(results);
}

export function aggregateQueryGenerator(input: NameAndOptions): null | [string, any] {
    const { name, options } = input;

    if (options.length === 0) return null;

    const aggs = Object.fromEntries(
        options.map(opt => [
            opt,
            {
                terms: {
                    field: `${opt}.keyword`,
                    size: 100,
                },
            },
        ]),
    );

    return [name, {
        filter: {
            term: {
                _index: name,
            },
        },
        aggs,
    },
    ];
}
function buildTermsQuery(name: string, value: any): object | null {
    if (typeof value !== 'string') return null;

    // // For 'card_languages', to avoid split of the value
    // if (name === 'card_languages') {
    //     return {
    //         terms: {
    //             [`${name}.keyword`]: [value], // wrap the full string in an array
    //         },
    //     };
    // }

    // Default behavior for other fields
    const keywords = value
        .split(',')
        .map((v: string) => v.trim())
        .filter((v: string) => v.length > 0);

    if (keywords.length === 0) return null;

    if (name === "companyTags") return null;

    return {
        terms: {
            [`${name}.keyword`]: keywords,
        },
    };
}

export function queryForTheAggregateFilters(
    names: string[],
    aggregates: Record<string, any>
): object[] {
    const queries = names
        .map((name) => buildTermsQuery(name, aggregates[`agg:${name}`] ?? aggregates[`radio:${name}`]))
        .filter((query): query is object => query !== null);

    return queries;
}